import { IPlacementRequirementKey } from 'app/models/Placement/PlacementDetails';
import { useWatch } from 'react-hook-form';
import { useEditableRequirement } from './EditRequirementsHelper';
import { dnsClearedCheck } from './EditablePassFailLogic';
import { useTranslation } from 'react-i18next';

export const useEditableRequirementDnsCleared = () => {
  const { t } = useTranslation();
  const dnsCleared: any = useWatch({ name: 'dnsCleared' });

  let message = t('placement.profile.summary.offer.confirmations.eligibilityClearedFail');

  if (dnsCleared?.checked === null || dnsCleared?.checked === undefined) {
    message = t('placement.profile.summary.offer.confirmations.eligibilityClearedNotSelected');
  }

  useEditableRequirement({
    data: dnsCleared?.checked,
    requirementId: IPlacementRequirementKey.dnsCleared,
    requirementKey: 'dnsCleared',
    requirementCheck: dnsClearedCheck,
    failRequirement: {
      id: IPlacementRequirementKey.dnsCleared,
      message: message,
      tooltip: {
        message: t('placement.profile.summary.offer.confirmations.eligibilityClearedTooltip'),
      },
    },
    riskRequirement: {
      id: IPlacementRequirementKey.dnsCleared,
      message: message,
      tooltip: {
        message: t('placement.profile.summary.offer.confirmations.eligibilityClearedTooltip'),
      },
    },
  });
};
